import React, { FC } from 'react';

interface ISavingsProducts {
  className: string;
}
const SavingsProducts: FC<ISavingsProducts> = (props) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.77415 6.6696L9.77976 6.66579L9.75994 6.59624C9.71637 6.4433 9.56412 6.32759 9.39902 6.34765C9.36778 6.34933 9.29252 6.35924 9.19023 6.38422C9.0741 6.41259 8.91767 6.46167 8.74087 6.54487C8.40555 6.70267 7.9972 6.98314 7.65272 7.47622C7.38773 7.30782 6.97337 7.15784 6.42665 7.2939C6.29067 7.31876 6.17495 7.43283 6.17132 7.59216C6.08104 8.23011 6.30852 8.84738 6.61311 9.35899C6.91339 9.86335 7.29499 10.2758 7.54673 10.5209C7.56261 10.5581 7.58055 10.5939 7.59555 10.6239L7.59581 10.6244C7.61109 10.6549 7.62183 10.6766 7.62833 10.6922C7.63652 10.863 7.64834 11.0075 7.66019 11.1146C7.66629 11.1697 7.67248 11.2156 7.67833 11.2505C7.68124 11.2679 7.68423 11.2835 7.68728 11.2966C7.68877 11.3031 7.69099 11.3121 7.69424 11.3217C7.72466 11.4852 7.88332 11.5873 8.03123 11.5873H8.07935V11.5881L8.09194 11.5865C8.27329 11.5635 8.4135 11.3849 8.36936 11.1958L8.36865 11.1913L8.36499 11.1666C8.36186 11.1447 8.35748 11.112 8.35259 11.0699C8.34373 10.9937 8.33319 10.8866 8.32534 10.7558C8.56217 10.4972 9.20018 9.75679 9.52878 9.10027L9.52879 9.10028L9.5295 9.0988C9.81895 8.49601 9.87602 7.88277 9.86173 7.41677C9.85457 7.18341 9.82949 6.98591 9.80619 6.84363C9.79454 6.77245 9.78333 6.71513 9.7751 6.67433L9.77415 6.6696ZM6.98193 8.07855C6.92097 8.12214 6.8807 8.17844 6.85884 8.23966C6.83699 8.13848 6.82353 8.03683 6.82021 7.9354C6.98566 7.93501 7.11772 7.97419 7.21929 8.02463C7.14084 8.01588 7.05976 8.03343 6.99043 8.0731L6.99018 8.07265L6.98193 8.07855ZM8.89417 8.78795C8.75741 9.0572 8.55621 9.35207 8.35435 9.6132C8.44364 9.0776 8.62876 8.48304 9.0089 7.96328L9.00891 7.96329L9.00953 7.96241C9.11815 7.81052 9.09978 7.60217 8.93823 7.48665C8.82315 7.40436 8.67566 7.39495 8.56069 7.46549C8.77006 7.28693 8.97687 7.18318 9.13941 7.12276C9.20062 7.494 9.20823 8.15929 8.90248 8.7713L8.89417 8.78795ZM8.00887 8.17268C8.1477 7.90645 8.30813 7.7028 8.47062 7.54698C8.4681 7.55025 8.46561 7.55358 8.46317 7.55697C8.17372 7.94341 7.97572 8.36361 7.84149 8.77622C7.86217 8.57284 7.91479 8.36895 8.00887 8.17268Z"
      fill="#213F7D"
      stroke="#213F7D"
      strokeWidth="0.2"
    />
    <path
      d="M4.46006 11.84C4.46006 12.0233 4.61671 12.18 4.80006 12.18C4.98341 12.18 5.14006 12.0233 5.14006 11.84V5.75996C5.14006 5.57661 4.98341 5.41996 4.80006 5.41996C4.61671 5.41996 4.46006 5.57661 4.46006 5.75996V11.84Z"
      fill="#213F7D"
      stroke="#213F7D"
      strokeWidth="0.2"
    />
    <path
      d="M2.86008 11.84C2.86008 12.0233 3.01673 12.18 3.20008 12.18C3.38344 12.18 3.54008 12.0233 3.54008 11.84V5.75996C3.54008 5.57661 3.38344 5.41996 3.20008 5.41996C3.01673 5.41996 2.86008 5.57661 2.86008 5.75996V11.84Z"
      fill="#213F7D"
      stroke="#213F7D"
      strokeWidth="0.2"
    />
    <path
      d="M10.8601 11.84C10.8601 12.0233 11.0167 12.18 11.2001 12.18C11.3834 12.18 11.5401 12.0233 11.5401 11.84V5.75996C11.5401 5.57661 11.3834 5.41996 11.2001 5.41996C11.0167 5.41996 10.8601 5.57661 10.8601 5.75996V11.84Z"
      fill="#213F7D"
      stroke="#213F7D"
      strokeWidth="0.2"
    />
    <path
      d="M12.4601 11.84C12.4601 12.0233 12.6167 12.18 12.8001 12.18C12.9834 12.18 13.1401 12.0233 13.1401 11.84V5.75996C13.1401 5.57661 12.9834 5.41996 12.8001 5.41996C12.6167 5.41996 12.4601 5.57661 12.4601 5.75996V11.84Z"
      fill="#213F7D"
      stroke="#213F7D"
      strokeWidth="0.2"
    />
    <path
      d="M13.5818 5.29997H13.36H2.64004C2.48648 5.29997 2.34567 5.19237 2.31862 5.04569C2.27553 4.88563 2.35048 4.75011 2.4727 4.66863L2.47684 4.66587L2.47691 4.66598L7.83662 1.46615C7.83666 1.46612 7.83671 1.4661 7.83675 1.46607L7.83691 1.46598L7.88817 1.55184C7.96817 1.50372 8.06442 1.50372 8.12817 1.55184L13.5818 5.29997ZM13.5818 5.29997L13.5366 5.24878C13.6335 5.18881 13.7013 5.08325 13.7149 4.97131L13.7156 4.9714V4.95926C13.7156 4.82907 13.6337 4.69696 13.517 4.64602L8.18352 1.46841L13.5818 5.29997ZM12.119 4.61997H3.86586L7.99994 2.14837L12.119 4.61997Z"
      fill="#213F7D"
      stroke="#213F7D"
      strokeWidth="0.2"
    />
    <path
      d="M2.64002 12.98H13.36C13.5434 12.98 13.7 12.8233 13.7 12.64C13.7 12.4566 13.5434 12.3 13.36 12.3H2.64002C2.45667 12.3 2.30002 12.4566 2.30002 12.64C2.30002 12.8233 2.45667 12.98 2.64002 12.98Z"
      fill="#213F7D"
      stroke="#213F7D"
      strokeWidth="0.2"
    />
    <path
      d="M1.8401 13.78H14.1601C14.3435 13.78 14.5001 13.6233 14.5001 13.44C14.5001 13.2566 14.3435 13.1 14.1601 13.1H1.8401C1.65674 13.1 1.5001 13.2566 1.5001 13.44C1.5001 13.6233 1.65674 13.78 1.8401 13.78Z"
      fill="#213F7D"
      stroke="#213F7D"
      strokeWidth="0.2"
    />
    <path
      d="M1.04005 14.5799H14.96C15.1434 14.5799 15.3 14.4233 15.3 14.2399C15.3 14.0566 15.1434 13.8999 14.96 13.8999H1.04005C0.856696 13.8999 0.700049 14.0566 0.700049 14.2399C0.700049 14.4233 0.856696 14.5799 1.04005 14.5799Z"
      fill="#213F7D"
      stroke="#213F7D"
      strokeWidth="0.2"
    />
  </svg>
);

export default SavingsProducts;
